import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=46945c5c&scoped=true&"
import script from "./Dev.vue?vue&type=script&lang=js&"
export * from "./Dev.vue?vue&type=script&lang=js&"
import style0 from "./Dev.vue?vue&type=style&index=0&id=46945c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46945c5c",
  null
  
)

export default component.exports